
 const Chip = ({
  label,
  variant = 'filled', // 'filled', 'outlined'
  size = 'medium', // 'small', 'medium', 'large'
  color = 'default', // 'default', 'primary', 'secondary', 'success', 'error', 'warning'
  clickable = false,
  deletable = false,
  disabled = false,
  avatar,
  icon,
  onClick,
  onDelete,
  className = '',
  sx = {}, // MUI-like sx prop for custom styles
  ...props
}) => {
  
  // Base Tailwind classes
  const baseClasses = "inline-flex items-center justify-center font-medium transition-all duration-200 outline-none border-0 select-none";
  
  // Size classes
  const sizeClasses = {
    small: "h-6 px-2 text-xs rounded-full",
    medium: "h-6 px-3 text-sm rounded-2xl", 
    large: "h-10 px-4 text-base rounded-2xl"
  };
  
  // Color classes for filled variant
  const filledColorClasses = {
    default: "bg-gray-200 text-gray-800",
    primary: "bg-blue-500 text-white",
    secondary: "bg-pink-500 text-white", 
    success: "bg-green-300 text-white",
    error: "bg-red-500 text-white",
    warning: "bg-orange-500 text-white"
  };
  
  // Color classes for outlined variant
  const outlinedColorClasses = {
    default: "bg-transparent border border-gray-300 text-gray-700",
    primary: "bg-transparent border border-blue-500 text-blue-500",
    secondary: "bg-transparent border border-pink-500 text-pink-500",
    success: "bg-transparent border border-green-500 text-green-500", 
    error: "bg-transparent border border-red-500 text-red-500",
    warning: "bg-transparent border border-orange-500 text-orange-500"
  };
  
  // Interactive classes
  const interactiveClasses = clickable && !disabled 
    ? "cursor-pointer hover:shadow-md hover:-translate-y-0.5 active:translate-y-0" 
    : "";
  
  // Disabled classes
  const disabledClasses = disabled ? "opacity-50 cursor-not-allowed pointer-events-none" : "";
  
  // Combine all classes
  const colorClasses = variant === 'outlined' 
    ? outlinedColorClasses[color] 
    : filledColorClasses[color];
    
  const allClasses = `${baseClasses} ${sizeClasses[size]} ${colorClasses} ${interactiveClasses} ${disabledClasses} ${className}`.trim();

  const handleClick = (e) => {
    if (!disabled && clickable && onClick) {
      onClick(e);
    }
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    if (!disabled && onDelete) {
      onDelete(e);
    }
  };

  // Avatar/Icon size classes
  const avatarSizeClasses = {
    small: "w-4 h-4",
    medium: "w-5 h-5", 
    large: "w-6 h-6"
  };

  // Delete button size classes
  const deleteSizeClasses = {
    small: "w-4 h-4 text-xs",
    medium: "w-5 h-5 text-sm",
    large: "w-6 h-6 text-base"
  };

  return (
    <div
      className={allClasses}
      onClick={handleClick}
      style={sx} // Apply sx styles directly
      {...props}
    >
      {avatar && (
        <div className={`${avatarSizeClasses[size]} -ml-1 mr-2 rounded-full overflow-hidden flex items-center justify-center`}>
          {avatar}
        </div>
      )}
      
      {icon && (
        <div className={`${avatarSizeClasses[size]} -ml-1 mr-2 flex items-center justify-center`}>
          {icon}
        </div>
      )}
      
      <span className="truncate text-white text-size-13">{label}</span>
      
      {deletable && (
        <button
          className={`${deleteSizeClasses[size]} -mr-1 ml-1 rounded-full hover:bg-black hover:bg-opacity-10 flex items-center justify-center transition-colors duration-150 ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
          onClick={handleDelete}
          disabled={disabled}
          aria-label="Delete"
        >
          ×
        </button>
      )}
    </div>
  );
};
export default Chip;